import { Component, OnInit, Input } from '@angular/core';
import { AjaxService } from 'src/app/shared/ajax.service'

@Component({
  selector: 'app-uploader',
  templateUrl: './uploader.component.html'
})

export class UploaderComponent implements OnInit {

  constructor(private ajax: AjaxService) { }
  @Input() cnf: { id: string, input:boolean, choos_button: boolean, upload_button: boolean, url: string }
  selectedFile: File

  ngOnInit() {
    this.cnf.input = this.cnf.input || false
    this.cnf.choos_button = this.cnf.choos_button || true
    this.cnf.upload_button = this.cnf.upload_button || true
  }

  onFileChanged(event) {
    this.selectedFile = event.target.files[0]
  }

  onChoose(cnf_id){
    document.getElementById(cnf_id).click()
  }
  onUpload() {
    var uploadData = new FormData()
    uploadData.append('file', this.selectedFile)
    if (!this.cnf.url) return

    this.ajax.execute({
      url: this.cnf.url,
      data: uploadData,
      type: 'post',
      contentType: false,
      processData: false,
    })
  }
}
